import api from "./api";

export const useProveedores = () => {

   const getProveedores = async () => {
    const { data } = await api.get("/proveedores");
    return data;
  };

  const editarProveedores = async (id, Proveedores) => {
    const { data } = await api.put(`/editar/proveedores/${id}`, Proveedores);
    return data;
  };

  const eliminarProveedores = async (id) => {
    const { data } = await api.delete(`/proveedores/eliminar/${id}`);
    return data;
  };

  

  return {
    getProveedores,
    editarProveedores,
    eliminarProveedores,
   
  };
}